import {
	AddCartItemDto,
	CalculateFeeResult,
	CartDto,
	IPricesOfProductsResults,
	ProductPackage,
	PurchaseProductDto,
} from '@bondsports/types';
import { SelectedAddonInterface } from 'types/addon';
import { RCTeam } from 'types/coreEntites/Team';
import { UserSettings } from 'types/userSettings';
import { Answer } from './answer';
import { RCLeagueSeason } from './coreEntites/Leagues';
import { Product } from './product';
import { IProductResource } from './product-resource';
import { ProgramProductInCart } from './program';
import { rcEnums } from './rc.enums';
import { ResourceInterface } from './resources';
import { ResourcesToProduct } from './resources-to-products';
import { Season } from './seasons';
import { UserPaymentMethod } from './payment';

export enum CheckoutArea {
	program = 'program',
	rental = 'rental',
	membership = 'membership',
	league = 'league',
	passes = 'passes',
}
export type Area = keyof typeof CheckoutArea;

export enum CheckoutStepsEnum {
	PACKAGE = 'package',
	SCHEDULE = 'schedule',
	ADDONS = 'addons',
	DETAILS = 'details',
	APPLICATION = 'application',
	INSURANCE = 'insurance',
	PAYMENT = 'payment',
	TEAMS = 'teams',
	FAMILY_MEMBERS = 'familyMembers',
}

export interface CheckoutStore {
	// The last step the user visited. Enables back-to-cart feature.
	lastReachedStep?: string;
	// Teams step
	selectedTeam?: RCTeam;
	// Details step
	selectedFamilyMember?: UserSettings | UserSettings[];
	// Payment step
	selectedPaymentMethod?: UserPaymentMethod;
	// Addon step
	selectedAddons?: SelectedAddonInterface[];
	// selectedAnswers
	selectedAnswers?: Answer[] | { userId: number; answers: Answer[] }[];
	// Amount to be payed as a deposit
	depositAmount?: number;
	taxes?: number[];
	selectedAnswersForInit?: { [x: string]: never };
	fees?: CalculateFeeResult[];
	subtotal?: number;
	cartService?: CartDto;
	skipCheckoutSteps?: CheckoutStepsEnum[];
}

export interface RentalCartItem {
	type: 'package' | 'addon';
	organizationId: number;
	id: number;
	spaceName: string;
	facilityName: string;
	picture: string;
	tags: string[];
	date: string;
	startTime: string;
	endTime: string;
	startHour: string;
	endHour: string;
	hours: number;
	price: number;
	name?: string;

	resourcePackageAmount: number;
	resourcePackageId: number;
	downpayment?: number | null;
}

export interface FlowStep {
	tabName: string;
	urlPath: string;
	isDisabled?: boolean;
}

export interface Facility {
	organizationId: number;
	facilityId: number;
	facilityName?: string;
	longDescription?: string;
}

export interface Space {
	spaceId?: number;
	spaceName?: string;
}

export interface IValidateParticipantData {
	organizationId: number;
	products: PurchaseProductDto[];
}

export interface ICheckoutKeys {
	Checkout: string;
	CheckoutCartItems: string;
	CheckoutCartBookingFee: string;
	CheckoutCartTotalPrice: string;
	CheckoutEventApplications: string;
}

export type discountsList = { groupName: string; totalGroupDiscount: number };

export interface ProgramCheckoutStore extends CheckoutStore {
	stepsCompletedOtherProducts?: ProgramProductInCart[];
	// products for which the user has already completed all the steps
	stepsCompleteProduct?: ProgramProductInCart[];
	// The Program the user selected in the landing page Search module
	selectedProgram?: string;
	// The Team
	selectedTeam?: RCTeam;
	// The sport the user registers to
	currentSport?: rcEnums.shared.SportsEnum;
	// The Program Season the user selected in the landing page Search module
	selectedSeason?: Season | RCLeagueSeason;
	// Package step
	selectedProduct?: Product;
	// Schedule step
	selectedSubSeason?: Season;
	// Schedule step
	selectedResources?: ResourcesToProduct;
	isAll?: boolean;
	// request payment
	requestOnly?: boolean;
	/* eslint-disable @typescript-eslint/no-explicit-any*/
	selectedAnswersForInit?: any;
	discountsList?: discountsList[];
	//  questionnaires to answer
	questionnaires?: number[];
	deletedAddons?: { [addonId: number]: number[] };
	calcPriceResponse?: IPricesOfProductsResults[];
	/* Used in details step,
	   For the iteration over all the selected members when validating membership gating
	*/
	requiredMembershipsIndex?: number;
	requiredMembershipsByUser?: { userId: number; requiredMemberships: IProductResource[] }[];
	/* Response from api call for product resources
	We save it here so it can be processed before even making it to the schedule page */
	productResources?: ResourceInterface;
	selectedProductPackage?: ProductPackage;
	membershipProducts?: AddCartItemDto[];
}

export interface CheckoutCartItemSummary {
	name?: string;
	description?: string;
	details?: string;
	price?: number;
	unitPrice?: number;
	quantity?: number;
}
